import axios from 'axios';

axios.defaults.baseURL = 'https://rl5qgrpxz6.execute-api.us-east-1.amazonaws.com/dev';

export function buildAuthenticationHeaders(credentials) {
  return {
    headers: {
      authorization: credentials.token,
    },
  };
}

export async function getProducts(credentials) {
  try {
    const response = await axios.get(`/get-products-by-email`, buildAuthenticationHeaders(credentials));
    return response.data;
  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function getSharedProducts(productIds) {
  try {
    const response = await axios.get(`/get-products-by-id?productIds=${productIds}`);
    return response.data;
  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function getMerchantProducts(credentials) {
  try {
    const response = await axios.get(`/shopify/products`, buildAuthenticationHeaders(credentials));
    return response.data;
  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function getCategories(credentials) {
  try {
    const response = await axios.get(`/get-categories`, buildAuthenticationHeaders(credentials));
    return response.data;
  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function addNewCategory(categories, credentials) {
  const response = await axios.post('/edit-category', categories, buildAuthenticationHeaders(credentials));
  console.log(response);
}

export async function addListIdToUser(credentials, listId) {
  try {
    const response = await axios.post('/add-listid', { listId }, buildAuthenticationHeaders(credentials));
    console.log(response);
  } catch (err) {
    console.log(err);
  }
}

export async function addProduct(productDetails, credentials) {
  const response = await axios.post('/add-product', productDetails, buildAuthenticationHeaders(credentials));
  console.log(response);
}

export async function shareProduct(product, credentials) {
  const response = await axios.post('/share-product', product, buildAuthenticationHeaders(credentials));
  console.log(response);
}

export async function removeProduct(id, credentials) {
  const response = await axios.post('/remove-products', id, buildAuthenticationHeaders(credentials));
  console.log(response);
}

export async function addComment(comment, credentials) {
  try {
    const response = await axios.post('/add-comment', comment, buildAuthenticationHeaders(credentials));
    console.log(response);
  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function addReaction(reaction, credentials) {
  try {
    const response = await axios.post('/add-like', reaction, buildAuthenticationHeaders(credentials));
    console.log(response);
  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function removeReaction(reaction, credentials) {
  try {
    const response = await axios.post('/remove-like', reaction, buildAuthenticationHeaders(credentials));
    console.log(response);
  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function removeComment(comment, credentials) {
  try {
    const response = await axios.post('/remove-comment', comment, buildAuthenticationHeaders(credentials));
    console.log(response);
  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function editProduct(product, credentials) {
  const response = await axios.post('/edit-product', product, buildAuthenticationHeaders(credentials));
  console.log(response);
}

export async function registerUser(user) {
  const response = await axios.post('/register', user);
  return response.data;
}

export async function loginUser(user) {
  const response = await axios.post('/login', user);
  return response.data;
}
